import React from "react";
import styles from "./HeadLine.module.css";
import useMediaQuery from "hooks/useMediaQuery";

export default function HeadLine() {
    const isMobile = useMediaQuery("(max-width: 1023px)");
    return (
        <>
            <div className={styles.blank} />
            <div className={styles.headLine}>
                <div className={styles.text5}>
                    주차,{" "}
                    <span className={styles.highlight}>
                        더 스마트 하게,{isMobile ? <br /> : " "}
                    </span>
                    빠른 주차 공간 확인에는{" "}
                    <span className={styles.highlight}>
                        Capl
                    </span>
                </div>
            </div>
        </>
    );
};
